import KendoDatePickerMixin from './KendoDatePickerMixin'

export default {
    name: 'kendo-datepicker',
    mixins: [ KendoDatePickerMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDatePicker/index.js